import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
} from "@mui/material";

import SafetyCheckIcon from "@mui/icons-material/SafetyCheck";

import DefaultButton from "../simple/DefaultButton";

interface Props {
  open: boolean;
  remainingMs: number;
  onExtend: () => void;
  onLogout: () => void;
}

function formatCountdown(ms: number): string {
  const totalSeconds = Math.ceil(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  if (minutes > 0) {
    return `${minutes}:${String(seconds).padStart(2, "0")}`;
  }
  return `${seconds}s`;
}

export function SessionTimeoutWarning({
  open,
  remainingMs,
  onExtend,
  onLogout,
}: Props) {
  return (
    <Dialog
      open={open}
      aria-labelledby="session-timeout-title"
      aria-describedby="session-timeout-desc"
      // role="alertdialog" announces immediately to screen readers
      role="alertdialog"
      disableEscapeKeyDown
      slotProps={{
        backdrop: {
          sx: {
            backdropFilter: "blur(8px)",
            WebkitBackdropFilter: "blur(8px)",
            backgroundColor: "rgba(8, 7, 28, 0.75)",
          },
        },
      }}
      PaperProps={{
        sx: {
          background: "#13112E",
          border: "1px solid #211F45",
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: `
            0 0 0 1px rgba(168, 126, 255, 0.25),
            0 8px 32px rgba(0, 0, 0, 0.6),
            0 32px 80px rgba(0, 0, 0, 0.5)
          `,
        },
      }}
    >
      <DialogTitle
        id="session-timeout-title"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "20px",
          borderBottom: "1px solid #211F45",
          fontSize: "16px",
        }}
      >
        Your session is about to expire
      </DialogTitle>
      <DialogContent
        sx={{
          padding: "30px 20px !important",
          borderBottom: "1px solid #211F45",
          textAlign: "center",
        }}
      >
        <DialogContentText
          id="session-timeout-desc"
          sx={{
            color: "#fff",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            fontSize: "14px",
            gap: "15px",
            "& strong": {
              display: "block",
              fontSize: "30px",
              color: "#01ECFF",
            },
            "& svg": {
              fill: "#01ECFF",
              fontSize: "60px",
            },
          }}
        >
          <SafetyCheckIcon />
          You will be automatically signed out in{" "}
          <strong>{formatCountdown(remainingMs)}</strong>
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          padding: "20px !important",
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          "& button": {
            margin: "0!important",
            width: "100%",
            "&:last-child": {
              color: "rgb(213, 215, 218)",
              fontFamily: "inherit",
              border: 0,
              background: "transparent",
              fontWeight: "600",
              cursor: "pointer",
            },
          },
        }}
      >
        <DefaultButton onClick={onExtend} variant="contained" autoFocus>
          Stay signed in
        </DefaultButton>
        <button onClick={onLogout}>Sign out now</button>
      </DialogActions>
    </Dialog>
  );
}
